export default __webpack_public_path__ + "static/media/webwhite.fabf5a08.png";